(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name trainingRoster.controller:TrainingRosterCtrl
   *
   * @description
   *
   */
  angular
    .module('trainingRoster')
    .directive('focusOn',function($timeout) {
      return {
        restrict : 'A',
        link : function(vm,$element,$attr) {
          vm.$watch($attr.focusOn,function(_focusVal) {
            $timeout(function() {
              _focusVal ? $element[0].focus() : $element[0].blur();
            });
          });
        }
      }
    })
    .controller('TrainingRosterCtrl', TrainingRosterCtrl);

  function TrainingRosterCtrl(EventManagerService,TrainingRosterService,MessageService,PopupManager,applicationConstants,AutoRosterScheduleService,TrainingProgramsService,CommonMasterData,TrainingProgramEditorService, StorageServices, TabService) {
    var vm = this;
    vm.ctrlName = 'TrainingRosterCtrl';

    vm.model = {
      searchOnGoing : false,
      searchPanelToggle:true,
      initialSearchDone: false,
      editorMode:applicationConstants.EDITOR_STATUS.ADD,
      searchCriteria:{
        cycle : null
      },
      masterList:{
        cycleList:[],
        trainingCategories:[],
        crewTypes:[],
        programDetails:[],
        allProgramDetails:[],
        allSelect:false,
        fromDateAfterToDate :false,
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        numberOfInitialSearches : 0,
        expiryStart : 1
      },

      isElasticLoadingVisible:false,

      selectedTraining:null,
      trainingList:[],
      showBottomPanel:false,
      summaries :[],
      summaryProgramTypes :[],
      selectedConfigsForRun:[]

    };

    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.searchByOptions = function(searchParams){
      setDefault();
      vm.searchTrainings();
    }

    vm.searchTrainings = function() {
      vm.model.trainingList = [];
      vm.model.searchCriteria.startPosition = 1;
      vm.model.initialSearchDone = true;

      searchTrainings();
    };

    vm.clickOnBottomPanelView = function() {
      vm.model.showBottomPanel = !vm.model.showBottomPanel;
    };

    vm.selectTraining = function (selectedRowData,flag) {
        if(flag == 'SELECT_ALL'){
          selectDeselectAll();
        }
        else if(flag == 'run'){
          setTrainingAsSelected(selectedRowData);
          vm.assignTrainings();
        }
        else if(flag == 'delete'){
            setTrainingAsSelected(selectedRowData);
            vm.deleteTrainings();
        }
        else{
          vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
          vm.model.selectedTraining = TrainingRosterService.formatGridSelectedRow(selectedRowData,vm.model.masterList);

          vm.model.masterList.programDetails =  _.filter(vm.model.masterList.allProgramDetails ,function(prog){return _.contains(selectedRowData.trainingProgramId,prog.trainingProgramId)})
          vm.model.selectedTraining.programDetailsObject = vm.model.masterList.programDetails;
        }


    };

    function selectDeselectAll() {
      vm.model.trainingList.forEach(function(training) {
        if(training.processingStatus === 'SCHEDULED') {
          training.isSelected = vm.model.masterList.allSelect;
        }
      });
    };

    function setTrainingAsSelected(selectedRowData){

    	vm.model.trainingList.forEach(function (trn) {
    		if(trn.trainingAutomationConfigId == selectedRowData.trainingAutomationConfigId){
    			trn.isSelected = true;
    		}
        });

    };

    vm.addNewTraining = function () {
      vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
      vm.model.selectedTraining = TrainingRosterService.getNewTraining();
      if(vm.model.searchCriteria.cycle){
        vm.model.selectedTraining.cycle = vm.model.searchCriteria.cycle;
        var start = new Date(vm.model.searchCriteria.cycle.dateFrom.split('/')[2],vm.model.searchCriteria.cycle.dateFrom.split('/')[1]-1,vm.model.masterList.expiryStart);
        vm.model.selectedTraining.expiryStart = start.getDate()+"/"+(start.getMonth()+1)+"/"+start.getFullYear() ;
        start.setMonth(start.getMonth() + 1);
        start.setDate(start.getDate() -1);
        vm.model.selectedTraining.expiryEnd = start.getDate()+"/"+(start.getMonth()+1)+"/"+start.getFullYear();
      }
    };

    vm.submitTraining = function(action, selectedItem) {
      vm.model.selectedTraining = selectedItem;
      if (action === applicationConstants.EDITOR_STATUS.DELETE){
        deleteTainingAutomation(selectedItem);
      }else{
        if(validateParam()) {
          saveTrainingAutomation();
        }
      }
    }

    vm.clickAddSlot = function (selectedItems,flag){
    	if(flag == 'addSlot'){
    		navigateToTrainingProgram(selectedItems);
    	}else if(flag == 'assignedCrew'){
        var details = {
          "selectedRow": selectedItems.assignedCrew,
          "title": "Assigned Crew",
          "isAssigned": true,
          "rosterCycle": vm.model.searchCriteria.cycle
        }
        PopupManager.openModal('ASSIGNED_TRAINEES', details,null,null);
      }else if(flag == 'unassignedCrew'){
        var details = {
          "selectedRow": selectedItems.unassignedCrew,
          "title": "Unassigned Crew",
          "isAssigned": false,
          "rosterCycle": vm.model.searchCriteria.cycle
        }
        PopupManager.openModal('ASSIGNED_TRAINEES', details,null,null);
      }
    }

    function searchTrainings() {
      showLoader(true);
      var searchParams = vm.model.searchCriteria;
      TrainingRosterService.searchTrainingAutomationGridData(
        searchParams,
        function (training,summaries) {
          updateTrainingList(training);
          vm.model.summaries = [];
          vm.model.summaries = summaries;

         // updateGridSearchStartPosition(startPosition);
          vm.model.searchPanelToggle = false;
          showLoader(false);
          vm.model.searchOnGoing = false;
          setProgramTypes(summaries);
        },
        function (error) {
          MessageService.error(error);
          showLoader(false);
        }
      );
    }

    function setProgramTypes(summaries) {
		angular.forEach(summaries, function(summary) {
			if(!vm.model.summaryProgramTypes.includes(summary.trainingProgramCode)){
				vm.model.summaryProgramTypes.push(summary.trainingProgramCode);
			}
		});
    }


    function getNextSetOfRecords() {
      vm.model.isElasticLoadingVisible = true;
      if(!vm.model.searchOnGoing){
        vm.model.searchOnGoing = true;
        searchAirports();
      }
    }

    function setDefault() {
      vm.model.searchCriteria.pageSize = 100;
      vm.model.searchCriteria.startPosition = 1;
      vm.addNewTraining();
    }

    function updateTrainingList(training) {
      vm.model.trainingList = [];
      angular.forEach(training, function (training) {
        vm.model.trainingList.push(training);
      });
      vm.model.isElasticLoadingVisible = false;
    }

    function showLoader(flag) {
      EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
        flag: flag,
        target: 'airport',
        animationName: 'crewing-loader'
      });
    }

    function updateGridSearchStartPosition(startPosition) {
      vm.model.searchCriteria.startPosition = startPosition;
    }

    function validateParam(){
      if(!vm.model.masterList.fromDateAfterToDate && !vm.model.masterList.toDateFormatInvalid && !vm.model.masterList.fromDateFormatInvalid){
        return true
      }
      return false;
    }

    function saveTrainingAutomation() {
      TrainingRosterService.saveTrainingAutomation(vm.model.selectedTraining, function (response) {
          if(response.success) {
            if(vm.model.searchCriteria.cycle) {
              searchTrainings();
            }
            vm.addNewTraining();
            MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME.SUCCESS_SAVE);
            return false;
          }
          return true;
        },
        function (error) {
          MessageService.error(error);
          vm.addNewTraining();
          return true;
        });

    }

    function deleteTainingAutomation(selectedItem){
      var param = {
        title: 'Confirmation',
        messages: ["Do you want to delete this record"],
        flags: selectedItem
      };
      PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
    }


    function confirmDeleteDialog(pass) {
      if(pass==='YES'){
        TrainingRosterService.deleteTrainingAutomation(vm.model.selectedTraining.trainingAutomationConfigId, function (response) {
            if(response.success) {
              if(vm.model.searchCriteria.cycle) {
                searchTrainings();
              }
              vm.addNewTraining();
              MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME_AUTOMATION.DELETE_SUCCESS);
            }

          },
          function (error) {
            MessageService.error(error);
            vm.addNewTraining();
          });

      }
    }


    vm.deleteTrainings = function(){
        createSelectedConfigList();
        if(validateRunAutomation()) {
        	deleteTrainingAutomation();
        }else{
          MessageService.warning(MessageService.MESSAGES.TRAINING_PROGRAME_AUTOMATION.INVALID_INPUT);
        }
    };


    function deleteTrainingAutomation(){
      	var param = {
      	        title: 'Confirmation',
      	        messages: ["Do you want to delete Training Roster"],
      	        flags: []
      	      };
      	PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteTrainingRoster);
    }


    function confirmDeleteTrainingRoster(pass){
      	if(pass==='YES'){
      		TrainingRosterService.deleteTrainingDistribution(vm.model.selectedConfigsForRun, function (response) {
      			if (response.success) {
      				MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME_AUTOMATION.DELETE_DISTRIBUTION_SUCCESS);
      				vm.searchByOptions();
      				vm.model.selectedConfigsForRun = [];
      			}
      		},
      		function (error) {
      			MessageService.error(error);
      		});
      	}
    }

    vm.assignTrainings = function(){

        createSelectedConfigList();
        if(validateRunAutomation()) {
        	runTrainingAutomation();
        }else{
          MessageService.warning(MessageService.MESSAGES.TRAINING_PROGRAME_AUTOMATION.INVALID_INPUT);
        }
      };

    function runTrainingAutomation(){
    	var param = {
    	        title: 'Confirmation',
    	        messages: ["Do you want to run Training Roster"],
    	        flags: []
    	      };
    	PopupManager.openModal('CONFIRM_DIALOG', param, confirmRunTrainingRoster);
    }

    function confirmRunTrainingRoster(pass){
    	if(pass==='YES'){
    		TrainingRosterService.assignTrainings(vm.model.selectedConfigsForRun, function (response) {
    			if (response.success) {
    				MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME_AUTOMATION.ASSIGN_SUCCESS);
    				vm.searchByOptions();
    				vm.model.selectedConfigsForRun = [];
    			}
    		},
    		function (error) {
    			MessageService.error(error);
    		});
    	}
    }

    function createSelectedConfigList(){
    	vm.model.selectedConfigsForRun = [];
    	vm.model.trainingList.forEach(function (trn) {
        if(trn.isSelected){
           vm.model.selectedConfigsForRun.push(trn.trainingAutomationConfigId);
         }
       });
    }

    function validateRunAutomation(){
    	if(vm.model.selectedConfigsForRun.length<= 0){
    		return false;
    	}
    	return true;
    }

    vm.viewMoreDetails = function(){
    	loadTrainingSchedule();

    };

    function loadTrainingSchedule(){
    	var tabName = 'trainingSchedule';

        StorageServices.setTabData(tabName, 'trainingScheduleParams', {
        	startDate: vm.model.searchCriteria.cycle.dateFrom,
        	endDate: vm.model.searchCriteria.cycle.dateTo,
        	programTypes : vm.model.summaryProgramTypes
        });
        TabService.gotoTab(tabName, {
        	startDate: vm.model.searchCriteria.cycle.dateFrom
        });

    }



    function navigateToTrainingProgram(selectedData){
    	var tabName = 'trainingPrograms';

        StorageServices.setTabData(tabName, 'trainingProgramsParams', {
        	startDate: vm.model.searchCriteria.cycle.dateFrom,
        	endDate: vm.model.searchCriteria.cycle.dateTo,
        	categoryCode:selectedData.trainingCategory
        });
        TabService.gotoTab(tabName, {
        	startDate: vm.model.searchCriteria.cycle.dateFrom
        });
    }


    vm.changeEditorField = function (flag, operation, selectedItems) {
      if(flag==='category'){
        loadProgramDetails(selectedItems);
      }else if(flag === 'fromDate' || flag === 'toDate'){
        setDateValidationFlags();
        if(!!vm.model.selectedTraining.expiryStart && !!vm.model.selectedTraining.expiryEnd
          && !vm.model.fromDateFormatInvalid  && !vm.model.toDateFormatInvalid){
          if (istoDateBeforeFromDate()) {
            vm.model.masterList.fromDateAfterToDate = true;
          }else{
            vm.model.masterList.fromDateAfterToDate = false;
          }
        }
      }else if(flag === 'cycle'){
        var start = new Date(vm.model.selectedTraining.cycle.dateFrom.split('/')[2],vm.model.selectedTraining.cycle.dateFrom.split('/')[1]-1,vm.model.masterList.expiryStart);
        vm.model.selectedTraining.expiryStart = start.getDate()+"/"+(start.getMonth()+1)+"/"+start.getFullYear() ;
        start.setMonth(start.getMonth() + 1);
        start.setDate(start.getDate() -1);
        vm.model.selectedTraining.expiryEnd = start.getDate()+"/"+(start.getMonth()+1)+"/"+start.getFullYear();
      }
    }

    function setDateValidationFlags(){
      //if from date invalid
      if(isDateFormatInvalid(vm.model.selectedTraining.expiryStart)){
        vm.model.masterList.fromDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterToDate = false;
      }else{
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      //if to date invalid
      if(isDateFormatInvalid(vm.model.selectedTraining.expiryEnd)){
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterToDate = false;
      }else{
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date){
      if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.selectedTraining.expiryEnd, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.selectedTraining.expiryStart,
            "DD/MM/YYYY"));
    };

    function loadProgramDetails(selectedItems){
      var categories =[];
      angular.forEach( selectedItems, function(category){
        if(!categories.includes(category.categoryCode.trim())){
          categories.push(category.categoryCode.trim());
        }
      });
      vm.model.masterList.programDetails = vm.model.masterList.allProgramDetails.filter(function(prog){return categories.includes(prog.categoryCode)});
    };

    (function(){
      CommonMasterData.getNumberOfInitialSearches(function (response) {
        vm.model.masterList.numberOfInitialSearches = response;
      },function (error) {});
      CommonMasterData.getTrainingRosterExpiryStartDate(function (response) {
        vm.model.masterList.expiryStart = response;
      },function (error) {});
      AutoRosterScheduleService.getRosterCycles(function (response) {
        vm.model.masterList.cycleList = response;
        var intialSearchCycleList = [];
        var currentDate = new Date();
        //filter past roster cycles
        intialSearchCycleList = response.filter(function (cycle) {
          var cycleFrom = cycle.dateFrom.split('/');
          cycleFrom = new Date(cycleFrom[2], cycleFrom[1] - 1, cycleFrom[0]);
          return cycleFrom > currentDate;
        });
        //sort
        intialSearchCycleList.sort(function (cycle1, cycle2) {
          var date1 = cycle1.dateFrom.split('/');
          date1 = new Date(date1[2], date1[1] - 1, date1[0]);

          var date2 = cycle2.dateFrom.split('/');
          date2 = new Date(date2[2], date2[1] - 1, date2[0]);

          if (date1 > date2) return 1;
          if (date1 < date2) return -1;
          return 0;
        });
          vm.model.searchCriteria.cycle = intialSearchCycleList[Math.min(vm.model.masterList.numberOfInitialSearches-1,intialSearchCycleList.length)];
        setDefault();
        vm.model.searchCriteria.startPosition = 1;
        vm.model.initialSearchDone = true;
          searchTrainings();
      },function (error) {});
      TrainingProgramsService.getTrainingCategories(function(response){
        response.forEach(function (category) {
          if(category.showInTrainingAutomation === 'Y'){
            vm.model.masterList.trainingCategories.push(category);
          }
        });
      },function(error){});
      CommonMasterData.getCrewTypeList(function (response) {
        vm.model.masterList.crewTypes = response;
      },function (error) {});
      TrainingRosterService.getAllTrainingPrograms(function (response) {
        vm.model.masterList.allProgramDetails = response;
      },function (error) {});
    })();


    setDefault();


  }
}());
